// src/features/tidsregistering/components/absence-planner/AbsenceBarTooltip.jsx
import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { APPROVAL_LABELS, APPROVAL_COLORS } from '../../constants/absence';
import LightTooltip from '../../../../components/common/LightTooltip';

function TooltipContent({ slot }) {
  const { t } = useTranslation(['tidsregistering', 'common']);
  const { registrationCode, originalAbsence, approvalState } = slot;

  return (
    <Box sx={{ p: 1.5, minWidth: 160 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.75 }}>
        {registrationCode?.title ?? t('tidsregistering:absence_planner.unknown_code')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, mb: 0.75 }}>
        <Typography variant="caption" color="text.secondary">
          {originalAbsence?.start_date} – {originalAbsence?.end_date}
        </Typography>
        {originalAbsence?.hours_sum != null && (
          <Typography variant="caption" color="text.secondary">
            {Number(originalAbsence.hours_sum).toFixed(1)} {t('common:hours_short')}
          </Typography>
        )}
      </Box>
      <Chip
        label={t(`tidsregistering:absence_planner.approval.${APPROVAL_LABELS[approvalState] ?? 'unknown'}`)}
        color={APPROVAL_COLORS[approvalState] ?? 'default'}
        size="small"
      />
    </Box>
  );
}

export default function AbsenceBarTooltip({ slot, children }) {
  return (
    <LightTooltip
      title={<TooltipContent slot={slot} />}
      placement="top"
      arrow
      enterDelay={300}
    >
      {children}
    </LightTooltip>
  );
}
